import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Game } from '../types';

const API_URL = process.env.REACT_APP_API_URL || '';

const Home: React.FC = () => {
  const [games, setGames] = useState<Game[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchGames();
  }, []);

  const fetchGames = async () => {
    try {
      const res = await fetch(`${API_URL}/api/games`);
      const data = await res.json();
      setGames(data);
    } catch (error) {
      console.error('Error fetching games:', error);
    } finally {
      setLoading(false);
    }
  };

  const createNewGame = async () => {
    try {
      const res = await fetch(`${API_URL}/api/games`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          name: `Wie is de Mol ${new Date().getFullYear()}`,
          season: new Date().getFullYear()
        })
      });
      const newGame = await res.json();
      navigate(`/setup?gameId=${newGame.id}`);
    } catch (error) {
      console.error('Error creating game:', error);
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'setup': return 'Voorbereiden';
      case 'active': return 'Actief';
      case 'finished': return 'Afgelopen';
      default: return status;
    }
  };

  if (loading) {
    return <div className="page loading">Laden...</div>;
  }

  return (
    <div className="page">
      <div className="page-header">
        <h1>Wie is de Mol?</h1>
        <p>Speel mee en ontdek wie de mol is!</p>
      </div>

      <button className="btn btn-accent btn-block" onClick={createNewGame}>
        + Nieuw Spel Starten
      </button>

      <div style={{ marginTop: '30px' }}>
        <h2 style={{ color: 'var(--mol-light)', marginBottom: '15px' }}>Mijn Spellen</h2>
        
        {games.length === 0 ? (
          <div className="empty-state">
            <h3>Nog geen spellen</h3>
            <p>Start een nieuw spel om te beginnen!</p>
          </div>
        ) : (
          <div className="game-list">
            {games.map(game => (
              <div 
                key={game.id} 
                className="game-card"
                onClick={() => navigate(`/game/${game.id}`)}
              >
                <h3>{game.name}</h3>
                <p>{game.players.length} spelers • {game.episodes.length} afleveringen</p>
                <span className={`game-status ${game.status}`}>
                  {getStatusText(game.status)}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
